import Spacer from 'components/Spacer'
import Icons from 'components/Icons'

import Container from './styles'

const CheckboxField = function ({
  value,
  checked = false,
  onChange,
  label,
  labelclass,
  info,
}) {
  return (
    <Container className="checkbox" onClick={() => onChange(value, !checked)}>
      <div className={`checkbox-border ${checked ? 'checked' : ''}`}>
        <div
          className={`checkbox-border-indicator ${checked ? 'checked' : ''}`}
        />
      </div>
      <div className={`checkbox-label ${labelclass ? labelclass : ''}`}>
        {label}
      </div>
      {info && (
        <div className="menu-info-icon">
          <Spacer width={10} />
          <Icons icon="infoFilled" tooltip={info} />
        </div>
      )}
    </Container>
  )
}

export default CheckboxField
